import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe} from 'react-stripe-elements'
import {Button} from 'antd'

@inject('store') @observer
class StripeComponent extends Component {
  submit = async () => {
    let {token} = await this.props.stripe.createToken({name: 'Name'})
    this.props.store.subscription.subscribe(token.id)
  }

  render() {
    const {loading} = this.props.store.subscription
    return (
      <div className='stripe-wrapper'>
        <div className='card-container'>
          <div className='field'>
            <label>Card Number</label>
            <CardNumberElement className='stripe-element number'/>
          </div>
          <div className='inline-fields'>
            <div className='field'>
              <label>Expires On</label>
              <CardExpiryElement className='stripe-element expiry' style={{base:{color:'gray'}}}/>
            </div>
            <div className='field'>
              <label>Security Code</label>
              <CardCVCElement className='stripe-element cvc' style={{base:{color:'gray'}}}/>
            </div>
          </div>
        </div>
        <p className='text'>
          <span>Secure Payment</span> This is secure 128-bit SSL encrypted payment
        </p>
        <Button type='primary' size='large' onClick={this.submit} loading={loading}>Subscribe</Button>
      </div>
    )
  }
}

export default injectStripe(StripeComponent)
